import React from "react";
import { useTheme } from "../../hooks";
import Loader from "./Loader";
import { LoadingAnimation, LoadingLabel, Overlay, Parent } from "./LoadingStyles";
const Loading = ({ type, animated = true, label, styles = {}, }) => {
    const { Theme } = useTheme();
    const StylesOverride = { ...Theme.loading, ...styles };
    return (React.createElement(Parent, { id: "loading-blocker", styles: StylesOverride },
        React.createElement(Overlay, { styles: StylesOverride },
            React.createElement(LoadingAnimation, { animated: animated },
                React.createElement(Loader, { type: type }),
                React.createElement(LoadingLabel, { styles: StylesOverride }, label)))));
};
export default Loading;
//# sourceMappingURL=Loading.js.map